export default {
    "profile": "Προφίλ",
    "logout": "Αποσύνδεση",
    "dashboard": "Ταμπλό",
    "password": "Κωδικός πρόσβασης",
    "language": "Γλώσσα",
    "paymentbr": "Πληρωμή",
    "subscriptionPaymentMethod": "Συνδρομή & Τρόπος Πληρωμής",
    "nothingchanged": "Τίποτα δεν άλλαξε",
    "somethingWentWrong": "Κάτι πήγε στραβά ! Δοκιμάστε ξανά αργότερα",
    "pleaseTryAgainAfterSometime": "Δοκιμάστε ξανά μετά από λίγο",
    "noChanges": "Δεν άλλαξε",
    "invalidEmailFormat": "Η μορφή email δεν είναι έγκυρη",
    "chooseYourPreferredLanguage": "Επιλέξτε τη γλώσσα που προτιμάτε.",
    "selectLanguage": "Επιλέξτε γλώσσα",
    "update": "Εκσυγχρονίζω",
    "languagePreferences": "Προτιμήσεις γλώσσας",
    "packageOf": "Πακέτο Από",
    "satelliteReport": "δορυφορικές αναφορές",
    "pastureReport": "εκθέσεις βοσκοτόπων",
    "upTo": "Μέχρι και",
    "animals": "των ζώων",
    "back": "Πίσω",
    "perMonth": "Κάθε μήνα",
    "perYear": "Ανά έτος",
    "continue": "Να συνεχίσει",
    "changePlan": "Αλλαγή σχεδίου",
    "addOn": "Πρόσθετο",
    "totalPrice": "Συνολικό ποσό",
    "availableAddOns": "Διαθέσιμα πρόσθετα",
    "next": "Επόμενο",
    "congratulations": "Συγχαρητήρια",
    "done": "ΕΓΙΝΕ",
    "deforestationComplianceAssessment": "Αξιολογήσεις συμμόρφωσης με την αποψίλωση των δασών",
    "warning": "Προειδοποίηση",
    "yourDataMightLost": "Τα δεδομένα σας ενδέχεται να χαθούν.",
    "clickOnSaveBtnMsg": "Κάντε κλικ στο κουμπί αποθήκευση για να διατηρήσετε τα δεδομένα σας",
    "discardChanges": "Απορρίψετε τις αλλαγές",
    "action": "Ενέργειες",
    "sendRequest": "Στείλε αίτημα",
    "success": "Επιτυχία",
    "yourRequestSuccessfullySubmitted": "Το αίτημά σας υποβλήθηκε με επιτυχία.",
    "informShortly": "Το αίτημά σας υποβλήθηκε με επιτυχία. Η αναφορά ανάλυσής σας θα σας σταλεί σύντομα.",
    "search": "Αναζήτηση",
    "pending": "εκκρεμής",
    "approved": "Εγκρίθηκε",
    "rejected": "Απορρίφθηκε",
    "primaryGeofence": "Πρωτεύον Geofence",
    "Zero/Negligible Deforestation Probability": "Μηδενική/Αμελητέα πιθανότητα αποψίλωσης",
    "Low Deforestation Probability": "Χαμηλή πιθανότητα αποψίλωσης",
    "High Deforestation Probability": "Υψηλή πιθανότητα αποψίλωσης",
    "login": {
        "welcome": "Καλως ΗΡΘΑΤΕ! Σύνδεση",
        "welInfo": "Εισαγάγετε τα διαπιστευτήριά σας.",
        "login": "Σύνδεση",
        "emailMobile": "Email/Κινητό",
        "forgotPassword": "Ξεχάσατε τον κωδικό",
        "register": "Κανω ΕΓΓΡΑΦΗ",
        "unableToLogin": "Αδύνατη η πρόσβαση",
        "emailMobileCannotEmpty": "Το email/κινητό δεν μπορεί να είναι κενό.",
        "invalidEmailMobileFormat": "Μη έγκυρη μορφή email/κινητού.",
        "passwordCannotEmpty": "Ο κωδικός πρόσβασης δεν μπορεί να είναι κενός.",
        "passwordLengthCanlessthan8": "Το μήκος του κωδικού πρόσβασης δεν μπορεί να είναι μικρότερο από 8 χαρακτήρες.",
        "email": "ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ",
        "phone": "Τηλέφωνο",
        "or": "Ή",
        "alreadyHaveAccount": "Εχετε ήδη λογαριασμό",
        "loginNow": "Συνδεθείτε τώρα",
        "registerOption": "Επιλέξτε μια επιλογή εγγραφής",
        "signUpWith": "Εγγράψου με"
    },
    "user": {
        "profileUpdated": "Το προφίλ ενημερώθηκε με επιτυχία",
        "profileNotUpdated": "Το προφίλ δεν έχει ενημερωθεί",
        "otpSentOnEmail": "Το OTP στάλθηκε με επιτυχία!",
        "otpSentSuccessFully": "Ο κωδικός OTP σας στάλθηκε",
        "unableToVerifyEmail": "Δεν είναι δυνατή η επαλήθευση του email",
        "emailCanNotBeEmpty": "Τα πεδία email δεν μπορούν να αδειάσουν",
        "firstName": "Ονομα",
        "lastName": "Επίθετο",
        "email": "ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ",
        "mobile": "Κινητό",
        "currentPassword": "Τρέχων κωδικός πρόσβασης",
        "newPassword": "Νέος Κωδικός",
        "repeatNewPassword": "Επαναλάβετε τον νέο κωδικό πρόσβασης",
        "firstNameRequired": "Το όνομα απαιτείται.",
        "lastNameRequired": "Το επώνυμο είναι υποχρεωτικό",
        "emailRequired": "Απαιτείται email",
        "onlyAlphabet": "Μπορεί να περιέχει μόνο αλφάβητα",
        "notMoreThan15Char": "Δεν μπορεί να είναι περισσότεροι από 15 χαρακτήρες",
        "phoneCannotLessThan8Char": "Το τηλέφωνο δεν μπορεί να είναι μικρότερο από 8 χαρακτήρες",
        "countryCodeRequire": "Απαιτείται κωδικός χώρας",
        "changePassword": "Άλλαξε κωδικό",
        "goodIdeaToUsePassword": "Είναι καλή ιδέα να χρησιμοποιήσετε έναν ισχυρό κωδικό πρόσβασης που δεν χρησιμοποιείτε αλλού.",
        "enterCurrentPassword": "Πληκτρολογήστε τον τρέχοντα κωδικό πρόσβασης",
        "enterNewPassword": "Εισάγετε νέο κωδικό",
        "reEnterPassword": "Εισαγάγετε ξανά τον κωδικό πρόσβασης",
        "pleaseTypeOldPassword": "Πληκτρολογήστε τον παλιό κωδικό πρόσβασης.",
        "pleaseTypeNewPassword": "Πληκτρολογήστε νέο κωδικό πρόσβασης.",
        "pleaseTypeConfirmPassword": "Πληκτρολογήστε τον κωδικό επιβεβαίωσης.",
        "passwordChangedSuccesFully": "Ο κωδικός άλλαξε επιτυχώς",
        "passwordDoesNotMatch": "Οι κωδικοί πρόσβασης δεν ταιριάζουν.",
        "passwordRequired": "Απαιτείται κωδικός",
        "emailOrPhoneIsRequired": "Απαιτείται email ή αριθμός τηλεφώνου"
    },
    "subscription": {
        "subscription": "Συνδρομή",
        "membershipPlan": "Σχέδια Μέλους",
        "currentMembershipPlan": "Τρέχον πρόγραμμα μέλους",
        "validUpTo": "Ισχύει μέχρι",
        "viewAllAddOns": "ΠΡΟΒΟΛΗ ΟΛΩΝ ΤΩΝ ΠΡΟΣΘΕΤΩΝ",
        "renewValidity": "Ανανέωση ισχύος",
        "buyNow": "Αγορασε τωρα",
        "upgradeMembershipPlan": "Αναβάθμιση προγράμματος μέλους",
        "chooseYourMembershipPlan": "Το επιλεγμένο σας πρόγραμμα μέλους",
        "chooseOptionalAddOns": "Μπορείτε να επιλέξετε προαιρετικά πρόσθετα",
        "yourSelectedAddons": "Τα επιλεγμένα πρόσθετά σας",
        "addAnotherAddOn": "Προσθήκη άλλου πρόσθετου",
        "paymentMethod": "Μέθοδος πληρωμής",
        "addingAPaymentMethod": "Προσθήκη μεθόδου πληρωμής",
        "paymentSuccessful": "Η πληρωμή σας ήταν επιτυχής!",
        "weHaveEmailed": "Έχουμε στείλει ένα αντίγραφο της απόδειξής σας στο example@email.com",
        "paymentAuthorizedSuccessfully": "Η πληρωμή εγκρίθηκε με επιτυχία.",
        "paymentSuccessfulPrompt": "Επιτυχής Πληρωμή. Το σχέδιο αναβαθμίστηκε.",
        "paymentCancelled": "Η πληρωμή ακυρώθηκε. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα."
    },
    "registerFarm": "Εγγραφή Αγρόκτημα",
    "requestDeforestationReport": "Ζητήστε αναφορά αποψίλωσης",
    "paymentMenu": "Πληρωμή",
    "complianceCertificate": "Πιστοποιητικό Συμμόρφωσης",
    "helpDisk": "Δίσκος βοήθειας",
    "faqs": "Συχνές ερωτήσεις",
    "enquiries": "Πληροφορίες",
    "contactUs": "Επικοινωνήστε μαζί μας",
    "payment": {
        "basicPlan": "Βασικό Σχέδιο",
        "advancePlan": "Πρόγραμμα εκ των προτέρων",
        "usdPerMonthPlus": "USD ανά μήνα συν",
        "perReport": "ανά έκθεση",
        "deforestationAnalyticsCertificateDownload": "Λήψη πιστοποιητικού ανάλυσης αποψιλώσεων"
    },
    "farm": {
        "farmOwnershipType": "Τύπος ιδιοκτησίας αγροκτήματος",
        "licenceNum": "ΑΡΙΘΜΟΣ ΑΔΕΙΑΣ",
        "viewFarm": "Δείτε το αγρόκτημα",
        "stateProvince": "ΕΠΑΡΧΙΑ",
        "postalNumberShouldSimilarToFarm": "Ο ταχυδρομικός αριθμός του αγροκτήματος παρόμοιος με τον αριθμό του σπιτιού.",
        "videoTutorial": "Εκμάθηση βίντεο",
        "clickOnMapMSG": "Κάντε κλικ στον χάρτη για να ξεκινήσετε τη γεωγραφική περίφραξη",
        "prev": "Προηγ",
        "next": "Επόμενο",
        "dragVertexMsg": "Μπορείτε επίσης να σύρετε την κορυφή ή να τις διαγράψετε χρησιμοποιώντας το κουμπί διαγραφής στη δεξιά πλευρά. Το Geofence μπορεί επίσης να καθαριστεί χρησιμοποιώντας το κουμπί διαγραφής",
        "farmAddedSuccessfully": "Το αγρόκτημα προστέθηκε με επιτυχία",
        "perimeter": "Περίμετρος",
        "area": "Περιοχή",
        "clearGeofence": "Καθαρίστε το Geofence",
        "deleteSelectedVertex": "Διαγραφή επιλεγμένης κορυφής",
        "pleaseStartDrawing": "Ξεκινήστε να σχεδιάζετε το geofence στο χάρτη.",
        "chooseTheDate": "Επιλέξτε την ημερομηνία",
        "updateGeofenceForThisFarm": "ΕΝΗΜΕΡΩΣΗ GEOFENCE για αυτό το αγρόκτημα",
        "farmUpdateSuccessfully": "Το αγρόκτημα ενημερώθηκε με επιτυχία",
        "farmZone": "Αγροτικές Ζώνες",
        "addNewZones": "Προσθήκη νέων ζωνών",
        "zoneName": "Όνομα ζώνης",
        "addZoneToCreate": "Κάντε κλικ στο Προσθήκη ζωνών για να δημιουργήσετε μια ζώνη για αυτό το αγρόκτημα.",
        "noZoneCreated": "Δεν έχουν δημιουργηθεί ακόμη Ζώνες.",
        "searchAndAddPin": "Αναζητήστε και προσθέστε μια καρφίτσα",
        "zoneNameWillBeHere": "Το όνομα της ζώνης θα είναι εδώ",
        "editZone": "Επεξεργασία ζώνης",
        "nameOfTheField": "Όνομα του Πεδίου",
        "zoneDetails": "Λεπτομέρειες ζώνης",
        "addZone": "Προσθήκη ζώνης",
        "nameOfTheZone": "Όνομα της ζώνης",
        "geofenceIsRequiredToAdd": "Το Geofence απαιτείται για την προσθήκη ζώνης. Κάντε κλικ στην «Επεξεργασία φάρμας» για να προσθέσετε λεπτομέρειες Geofence στο αγρόκτημά σας.",
        "thisFieldApplyHelpText": "Αυτό το πεδίο ισχύει για εσάς μόνο εάν ανήκετε σε οποιονδήποτε συνεταιρισμό (Ο συνεταιρισμός είναι μια αυτόνομη ένωση προσώπων που ενώνονται εθελοντικά για να ικανοποιήσουν τις κοινές οικονομικές, κοινωνικές και πολιτιστικές ανάγκες και φιλοδοξίες τους μέσω μιας κοινής ιδιοκτησίας και δημοκρατικά ελεγχόμενης επιχείρησης). ΕΑΝ ανήκετε σε συνεταιρισμό, υποδείξτε το μοναδικό αναγνωριστικό αυτού του συνεταιρισμού, μπορεί να είναι ένας αριθμός εγγραφής ή άδειας που προσδιορίζει μοναδικά τον συνεταιρισμό με τον οποίο συσχετίζετε.",
        "farmRegistrationID": "Ταυτότητα Εγγραφής Αγροκτήματος",
        "farmerName": "Όνομα αγρότη",
        "farmerRegistrationID": "Ταυτότητα εγγραφής αγρότη",
        "dateOfRequest": "Ημερομηνία της αίτησης",
        "status": "Κατάσταση",
        "address": "Διεύθυνση",
        "save": "Αποθηκεύσετε",
        "farmAddress": "Διεύθυνση τοποθεσίας φάρμας",
        "corporateName": "Εταιρική επωνυμία",
        "corporateMailingAddress": "Εταιρική Ταχυδρομική Διεύθυνση",
        "farmID": "Ταυτότητα αγροκτήματος",
        "onTheFarm": "Στην φάρμα",
        "userRoles": "Ρόλοι χρήστη",
        "adduser": "Πρόσθεσε χρήστη",
        "addAuser": "Προσθήκη χρήστη",
        "uploadUsers": "Μεταφόρτωση χρηστών",
        "addNewUser": "Προσθήκη νέου χρήστη",
        "selectDept": "Επιλέξτε Τμήμα",
        "selectRole": "Επιλέξτε Ρόλος",
        "editUser": "Επεξεργασία χρήστη",
        "totalFarms": "Total Farms",
        "NoAnimalsRegisteredForthisFarm": "Κανένα ζώο δεν έχει εγγραφεί για αυτό το αγρόκτημα",
        "farmsPerPage": "Αγροκτήματα ανά σελίδα",
        "regularFarms": "Τακτικά αγροκτήματα",
        "farmRegisteredProducts": "Προϊόντα Εγγεγραμμένα στη Φάρμα",
        "searchByFarmNameAndId": "Αναζήτηση κατά όνομα και αναγνωριστικό αγροκτήματος",
        "loadingProductsPleaseWait": "Φόρτωση προϊόντων... Περιμένετε",
        "farmName": "Όνομα αγροκτήματος",
        "farmLocation": "Τοποθεσία φάρμας",
        "productName": "Ονομασία προϊόντος",
        "stockStatus": "Κατάσταση μετοχών",
        "inStock": "Σε απόθεμα",
        "searchByProductName": "Αναζήτηση κατά όνομα προϊόντος",
        "productCategory": "κατηγορία προιόντος",
        "products": "Προϊόντα",
        "yourLocationIsDisabled": "Η τοποθεσία σας είναι απενεργοποιημένη. Αναζητήστε την τοποθεσία σας από τα αριστερά μενού.",
        "close": "Κλείσε",
        "farms": "Αγροκτήματα",
        "zones": "Ζώνες",
        "registerAfarm": "Καταχωρίστε ένα αγρόκτημα",
        "govtRegistry": "Κυβέρνηση Αρχείο",
        "cooperativeID": "Συνεταιριστική/Συνδικαλιστική Ταυτότητα",
        "cooperativeName": "Συνεταιρισμός/Συνδικαλιστικό Όνομα",
        "farmType": "Τύπος αγροκτήματος",
        "contractMating": "Συμβόλαιο ζευγάρωμα",
        "customization": "Προσαρμογή",
        "recordsPerpage": "Εγγραφές ανά σελίδα",
        "restoreDefault": "Επαναφορά προεπιλογής",
        "apply": "Ισχύουν",
        "CommunityName": "Ονομα κοινότητας",
        "searchState": "Αναζήτηση κατά Ταυτότητα Αγροκτήματος, Μητρώο Κυβερνήτη, Ταυτότητα Συνεταιρισμού, Τύπος Φάρμας, Ζευγάρισμα συμβολαίου",
        "farmOwner": "Ιδιοκτήτης φάρμας",
        "govRegistrationNo": "Κυβερνητικός αριθμός μητρώου",
        "farmInformation": "Πληροφορίες για το αγρόκτημα",
        "ownershipType": "Τύπος ιδιοκτησίας",
        "farmLicenseInformation": "Πληροφορίες άδειας εκμετάλλευσης",
        "licenseNumber": "ΑΡΙΘΜΟΣ ΑΔΕΙΑΣ",
        "licenseExpiryDate": "Ημερομηνία λήξης άδειας",
        "regulatorName": "Όνομα ρυθμιστή",
        "regulatorRepresentativeName": "Όνομα αντιπροσώπου της ρυθμιστικής αρχής",
        "farmLocationSize": "Τοποθεσία και μέγεθος αγροκτήματος",
        "productionSystem": "Γεωργικό Σύστημα",
        "country": "Χώρα",
        "state": "κατάσταση",
        "city": "Χωριό/Πόλη/Πόλη",
        "farmNumber": "Αριθμός αγροκτήματος",
        "postal": "Ταχυδρομικός/Τ.Κ",
        "houseNumber": "Τον αριθμό του σπιτιού",
        "farmRegistration": "Εγγραφή Αγροκτήματος",
        "cancel": "Ματαίωση",
        "register": "Κανω ΕΓΓΡΑΦΗ",
        "ok": "Εντάξει",
        "totalFarmSize": "Συνολικό μέγεθος αγροκτήματος",
        "geographicLocation": "Γεωγραφική θέση",
        "farmGeographicLocation": "Αγρόκτημα Γεωγραφική Τοποθεσία",
        "perimeterPointLongitude": "Περιμετρικό Μήκος Σημείου",
        "perimeterPointLatitude": "Περιμετρικό γεωγραφικό πλάτος",
        "perimeterPointLabel": "Ετικέτα περιμετρικού σημείου",
        "perimeterLength": "Μήκος Περιμέτρου",
        "farmLatitude": "Farm Latitude",
        "farmLongitude": "Γεωγραφικό μήκος αγροκτήματος",
        "latitude": "Γεωγραφικό πλάτος",
        "longitude": "Γεωγραφικό μήκος",
        "areaUnit": "Μονάδα Περιοχής",
        "walkAndMeasure": "ΠΕΡΠΑΤΑΤΕ ΚΑΙ ΜΕΤΡΑΤΕ",
        "useGeofenceTool": "ΧΡΗΣΙΜΟΠΟΙΗΣΤΕ ΤΟ ΕΡΓΑΛΕΙΟ GEOFENCE",
        "editFarm": "Επεξεργασία φάρμας",
        "update": "Εκσυγχρονίζω",
        "editAfarm": "Επεξεργαστείτε ένα αγρόκτημα",
        "nextFarm": "Επόμενο Αγρόκτημα",
        "nameoftheFarm": "Όνομα του αγροκτήματος",
        "registerAProduct": " Εγγραφή προϊόντος",
        "farmProducts": "Αγροτικά Προϊόντα",
        "calf": "Μοσχάρι",
        "steer": "Διευθύνω",
        "heifer": "Αγελαδίτσα",
        "sire": "Αρχοντας",
        "dam": "Φράγμα",
        "registerAnAnimal": "Εγγραφή ενός ζώου",
        "farmAnimals": "Εκτρεφόμενα ζώα",
        "farm_type": "Φάρμας τύπου",
        "farm_Owner": "Αγρόκτημα",
        "dateOfRegistration": "Ημερομηνία εγγραφής",
        "dataIsNotAvailableForThisFarm": "Τα δεδομένα δεν είναι διαθέσιμα για αυτό το αγρόκτημα",
        "registerNewProduct": "Εγγραφή Νέου Προϊόντος",
        "information": "Πληροφορίες",
        "licenseInfo": "Πληροφορίες άδειας χρήσης",
        "locationInfo": "Πληροφορίες τοποθεσίας",
        "geoLocation": "Γεωγραφική τοποθεσία",
        "perimeterLengthState": "Μήκος περιμέτρου αγροκτημάτων (μήκος φράχτη)",
        "totalFarmSizeState": "Μέγεθος ενός αγροκτήματος",
        "productionSystemState": "Σύστημα Παραγωγής που χρησιμοποιείται στο Αγρόκτημα",
        "contractMatingState": "Κώδικας Συμβολαίου Πρόγραμμα Ζευγαρώματος στο οποίο συμμετέχει η Φάρμα.",
        "ownershipTypeState": "Είδος ιδιοκτησίας",
        "regulatorRepresentativeNameState": "Όνομα του προσώπου που εκπροσωπεί τη ρυθμιστική αρχή που εξέδωσε την άδεια",
        "regulatorNameState": "Όνομα της ρυθμιστικής αρχής που εξέδωσε την άδεια",
        "licenseExpiryDateState": "Ημερομηνία κατά την οποία έχει λήξει η τρέχουσα άδεια",
        "licenseNumberState": "Αριθμός Άδειας Χρήσης που κυκλοφόρησε από τη Ρυθμιστική Αρχή",
        "plotNumberState": "Αριθμός σπιτιού του αγροκτήματος.",
        "plotNumber": "Αριθμός αγροκτήματος",
        "streetStatement": "Όνομα οδού του αγροκτήματος.",
        "cityStatement": "Πόλη στην οποία βρίσκεται το αγρόκτημα.",
        "stateStatement": "Περιοχή της χώρας στην οποία βρίσκεται το αγρόκτημα.",
        "countryState": "Χώρα στην οποία βρίσκεται το αγρόκτημα.",
        "farmStateInfo": "Διεύθυνση τοποθεσίας αγροκτήματος",
        "perimeterPointLongitudeState": "Γεωγραφικό μήκος ενός σημείου στο αγρόκτημα.",
        "perimeterPointLatitudeState": "Γεωγραφικό πλάτος ενός σημείου στο αγρόκτημα.",
        "perimeterPointLabelState": "Ετικέτα του σημείου.",
        "farmLongitudeState": "Γεωγραφικό μήκος του αγροκτήματος.",
        "farmLatitudeState": "Γεωγραφικό πλάτος του αγροκτήματος.",
        "deleteFarm": "Διαγραφή Farm",
        "corporateRegistrationNum": "Αριθμός εταιρικού μητρώου",
        "farmLocationIsRequired": "Απαιτείται τοποθεσία φάρμας."
    },
    "deforestation": {
        "addZoneToThisFarm": "Προσθέστε Ζώνες σε αυτό το αγρόκτημα",
        "eudrForestAssessment": "EUDR Δασικές Εκτιμήσεις",
        "requestEudrForestAssessment": "ΑΙΤΗΣΗ EUDR ΔΑΣΙΚΗ ΑΞΙΟΛΟΓΗΣΗ",
        "pleaseChooseOption": "Επιλέξτε Επιλογή",
        "requestForestReport": "Αίτημα Δασικής Αναφοράς",
        "noDeforestationReportMsg": "Δεν έχουν ζητηθεί αναφορές αποψίλωσης των δασών. Ζητήστε ορισμένες αναφορές αποψίλωσης για να τις καταχωρήσετε εδώ.",
        "allCountries": "Ολες οι χώρες",
        "allRegions": "Όλες οι Περιφέρειες",
        "allFarms": "Όλα τα αγροκτήματα",
        "allStatus": "Όλη η κατάσταση",
        "viewCertificate": "Δές το πιστοποιητικό",
        "requestComplianceCertificate": "ΑΙΤΗΣΤΕ ΠΙΣΤΟΠΟΙΗΤΙΚΟ ΣΥΜΜΟΡΦΩΣΗΣ",
        "assessmentNo": "Αξιολόγηση Αρ",
        "blockchainCertificationInfo": "Το Hash επικύρωσης πιστοποιητικού Blockchain θα είναι διαθέσιμο με την αποδοχή του πιστοποιητικού",
        "blockchainCertificationValidation": "Επικύρωση Πιστοποιητικού Blockchain",
        "openBlockchainPage": "Ανοίξτε τη σελίδα Blockchain",
        "clickOnAboveLink": "Κάντε κλικ στον παραπάνω σύνδεσμο για να επικυρώσετε το πιστοποιητικό στο blockchain",
        "shareCertificate": "Πιστοποιητικό κοινής χρήσης",
        "high": "Υψηλός",
        "low": "Χαμηλός",
        "zeroOrNegigible": "Μηδέν ή Αμελητέα",
        "deforestationProbability": "Πιθανότητα αποψίλωσης",
        "colorCode": "Κωδικός χρώματος",
        "geofenceAarea": "Περιοχή Geofence",
        "percentageOfGeofenceArea": "Ποσοστό της περιοχής Geofence",
        "overallDeforestationProbability": "Συνολική πιθανότητα αποψίλωσης των δασών",
        "deforestationComplianceReport": "Εκθέσεις συμμόρφωσης με την αποψίλωση των δασών",
        "noDeforestationComplianceReport": "Δεν βρέθηκε eReport Complianc Deforestation",
        "loadingDeforestationComplianceReport": "Φόρτωση eReport Complianc Deforestation",
        "farmRegistrationId": "Ταυτότητα Εγγραφής Αγροκτήματος",
        "farmerName": "Όνομα αγρότη",
        "farmerRegistrationId": "Ταυτότητα εγγραφής αγρότη",
        "uniqueFarmerId": "Μοναδική ταυτότητα αγρότη",
        "uniqueFarmId": "Μοναδική ταυτότητα φάρμας",
        "farmLocation": "Τοποθεσία φάρμας",
        "area": "Περιοχή",
        "farmAddress": "Διεύθυνση αγροκτήματος",
        "dateOfRequest": "Ημερομηνία της αίτησης",
        "status": "Κατάσταση",
        "settings": "Ρυθμίσεις",
        "assignmentIssued": "Εκδόθηκε Εργασία",
        "certificateIssued": "Εκδόθηκε Πιστοποιητικό",
        "complianceCertification": "Πιστοποίηση Συμμόρφωσης",
        "noComplianceCertification": "Δεν βρέθηκε Πιστοποίηση Συμμόρφωσης",
        "loadingComplianceCertification": "Φόρτωση πιστοποίησης συμμόρφωσης",
        "assessmentReport": "Έκθεση Αξιολόγησης",
        "downloadPDF": "Λήψη PDF",
        "print": "Τυπώνω",
        "back": "Πίσω",
        "farmDetails": "Λεπτομέρειες φάρμας",
        "dimitraFarmId": "Δήμητρα Αγρόκτημα Κωδ",
        "dimitraFermerId": "Δήμητρα Αγρότης Ιδ",
        "totalGeofenceAreaHA": "Συνολική περιοχή γεωγραφικής προστασίας (HA)",
        "forestLossHA": "Απώλεια δασών (HA)",
        "forestGainHA": "Forest Gain (HA)",
        "forestUnchangedHA": "Δάσος Αμετάβλητο (HA)",
        "forestUnchanged": "Δάσος Αμετάβλητο",
        "forestLoss": "Απώλεια Δάσους",
        "forestGain": "Κέρδος στο δάσος",
        "totalGeofenceArea": "Συνολική περιοχή Geofence",
        "forestAssessmentHelp": "Εάν έχετε ερωτήσεις σχετικά με αυτήν την αναφορά ή χρειάζεστε βοήθεια για την κατανόησή της, επικοινωνήστε μαζί μας μέσω του Help Desk.",
        "allReport": "Όλες οι αναφορές",
        "deforestationRepot": "Εκθέσεις αποψίλωσης δασών",
        "requestDeforestationReportNow": "ΖΗΤΗΣΤΕ ΑΝΑΦΟΡΑ ΑΠΟΔΑΣΩΣΗΣ ΤΩΡΑ",
        "noRecordFound": "Δεν Βρέθηκε Αρχείο",
        "noDeforestationReportRequested": "Δεν έχουν ζητηθεί αναφορές αποψίλωσης των δασών. Ζητήστε ορισμένες αναφορές αποψίλωσης για να τις καταχωρήσετε εδώ.",
        "deforestationImage": "Εικόνα αποψίλωσης",
        "reqDeforestationReport": "Ζητήστε αναφορά αποψίλωσης",
        "confirm": "Επιβεβαιώνω",
        "newForestArea": "Νέα Δασική Περιοχή",
        "deforestedArea": "Αποψιλωμένη Περιοχή",
        "existingForestArea": "Υφιστάμενη δασική έκταση",
        "deforestation": "Αποψίλωση των δασών",
        "farmName": "Όνομα αγροκτήματος",
        "location": "Τοποθεσία",
        "dateOfInterest": "Ημερομηνία ενδιαφέροντος",
        "geofenceArea": "Geofence Area (HA)",
        "deforestationArea": "Περιοχή αποψίλωσης των δασών (HA)",
        "treeGainArea": "Περιοχή κέρδους δέντρων (HA)",
        "currentForestArea": "Τρέχουσα δασική περιοχή (HA)",
        "view": "Θέα",
        "locationInfoRequired": "Απαιτούνται πληροφορίες τοποθεσίας",
        "geofenceNameRequired": "Το όνομα Geofence είναι υποχρεωτικό",
        "futureDateSelected": "Επιλέχθηκε η μελλοντική ημερομηνία",
        "reportGeneratedSuccessfully": "Η αναφορά δημιουργήθηκε με επιτυχία",
        "reportCannotAdded": "Δεν είναι δυνατή η προσθήκη αναφοράς.",
        "primaryFarmNotFound": "Το κύριο αγρόκτημα δεν βρέθηκε.",
        "pleaseRegisterFarmFirst": "Εγγραφείτε πρώτα στο αγρόκτημα"
    },
    "certificate": {
        "allCertificate": "Όλα τα Πιστοποιητικά",
        "certificate": "Πιστοποιητικό"
    }
}